export const ROLES = ['admin', 'recruiter', 'recommender', 'ngo-rep', 'candidate', 'guest'] as const;
export type Role = (typeof ROLES)[number];

export const STAFF_ROLES: Role[] = ['admin', 'recruiter'];

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && (ROLES as readonly string[]).includes(value);
}

export function isStaff(role: Role | null): boolean {
  return role !== null && STAFF_ROLES.includes(role);
}
